import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import axios from '../../tools/axiosWrapper';

import "./join.css";

export const Stop = () => {
    let [searchParams] = useSearchParams();

    const replyid = searchParams.get('a');
    const [isLoading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    async function fetchStop() {
        try {
            setLoading(true);
            await axios.get("/event/stop/", { params: { replyid } });
            setSuccess(true);
        } catch (error) {
            setSuccess(false);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchStop();
    }, []);

    let message = success ? 
        <span>External notifications for this event have been stopped. Any notifications already scheduled for events will still be sent but no further ones will be added.</span> : 
        <span>We could not change your notifications using this link.</span>;

    if (isLoading) {
        return (
            <main>
                <p>Loading...</p>
            </main>
        );
    }

    return (
        <main>
            <p>
                {message}
                <br />
                {success ? "You can" : "Please"} change your preferences in the JoinU@Harvard app or at <a href="app.joinu.org">app.joinu.org</a> for more information.</p>
        </main>
    );
};
